module.exports = __webpack_public_path__ + "static/media/slider3.74f84754.jpg";